import React, { useEffect, useRef } from "react";
import "./WhyChoose.css";
import { FaMicrochip, FaCogs, FaShippingFast, FaShieldAlt, FaStopwatch, FaHandshake } from "react-icons/fa";

function WhyChoose() {

  const sectionRef = useRef(null);

  const reasons = [
    { icon: <FaMicrochip />, title: "Precision Engineering", desc: "Surgical accuracy using DMLS and CNC processes." },
    { icon: <FaStopwatch />, title: "Agile Turnaround", desc: "Prototypes delivered in days, not weeks." },
    { icon: <FaCogs />, title: "Unified Platform", desc: "One source for Metal, Plastics, and Tooling." },
    { icon: <FaShieldAlt />, title: "Rigorous QA", desc: "Full traceability and material certifications." },
    { icon: <FaShippingFast />, title: "Global Logistics", desc: "Streamlined international export-grade shipping." },
    { icon: <FaHandshake />, title: "OEM Partnership", desc: "An extension of your internal engineering team." }
  ];

  useEffect(() => {
    const sec = sectionRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) sec.classList.add("show");
        else sec.classList.remove("show");
      },
      { threshold: 0.3 }
    );
    observer.observe(sec);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="why_root">
      <section id="why_section" ref={sectionRef}>
        <div id="why_container">

          <div id="why_header" className="reveal delay_1">
            <span id="why_eyebrow">The VB SHAH Edge</span>
            <h2 id="why_title">
              Why Industry Leaders <span>Choose Us</span>
            </h2>
          </div>

          <div id="why_grid">
            {reasons.map((item, index) => (
              <div id={`why_card_${index}`} key={index} className={`reveal delay_${index + 2}`}>
                <div id={`why_icon_${index}`}>{item.icon}</div>
                <div id={`why_text_${index}`}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </div>
  );
}

export default WhyChoose;
